export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const TRANSLATIONS = {
  // Attachments: upload
  ATTACHMENT_UPLOAD_SUCCESS: 'Attachment uploaded.',
  ATTACHMENT_UPLOAD_ERROR: 'Failed to upload attachment.',
  ATTACHMENT_FILE_TOO_LARGE: (maxMb: number) =>
    `File is too large. Maximum size is ${maxMb} MB.`,
  ATTACHMENT_SUPPORTED_FORMATS: 'Supported formats: .pdf, .jpg, .png.',
  ATTACHMENT_UPLOADING: 'Uploading…',
  ATTACHMENT_DRAG_OR: 'Drag your file or',
  ATTACHMENT_BROWSE: 'browse',

  // Attachments: list
  ATTACHMENT_NO_FILES_UPLOADED: 'No files uploaded',
  ATTACHMENT_UPLOADED_FILES: (count: number) => `Uploaded files (${count})`,

  // Attachments: delete
  ATTACHMENT_DELETE_SUCCESS: 'Attachment deleted.',
  ATTACHMENT_DELETE_ERROR: 'Failed to delete attachment.',

  // Attachments: download
  ATTACHMENT_DOWNLOAD_ERROR: 'Failed to download attachment.'
};
